module.exports = __webpack_public_path__ + "img/free_multiplier_4.99c26aa1.png";